import { ApolloClient, ApolloLink } from "@apollo/client/core";
import { getG11nDataFromHeaders, parseCookies } from "../utils/index.js";
import { apolloCacheConfig } from "./cache-config.js";
import { appReleaseLink, cloudflareAccessLink, countryPrefixLink, createIsomorphLink, crehanaCurrentUrlLink, customHeadersLink, distinctIdLink, errorLink, operationNameLink, userAgentLink } from "./links/index.js";
let apolloClient;
function createApolloClient(countryCode, pageKey) {
    let links = [
        errorLink,
        distinctIdLink,
        crehanaCurrentUrlLink,
        appReleaseLink,
        userAgentLink,
        cloudflareAccessLink,
        customHeadersLink,
        operationNameLink(pageKey),
        countryPrefixLink(countryCode),
        createIsomorphLink()
    ];
    if ("u" < typeof window) {
        const logLink = new ApolloLink((operation, forward)=>{
            console.info('Request', operation.operationName);
            return forward(operation).map((result)=>{
                console.info('Response', operation.operationName, (operation.getContext()?.response).status);
                return result;
            });
        });
        links = [
            logLink,
            ...links
        ];
    }
    const mfName = process.env.CREHANA_MICROFRONTEND_NAME || 'unknown';
    return new ApolloClient({
        ssrMode: "u" < typeof window,
        link: ApolloLink.from(links),
        credentials: 'include',
        cache: apolloCacheConfig,
        name: `crehana-frontend-${mfName}`,
        version: process.env.APP_VERSION || process.env.NEXT_PUBLIC_COMMIT_SHA || process.env.VERCEL_GIT_COMMIT_SHA || process.env.COMMIT_SHA || 'unknown'
    });
}
function initializeApolloClient(options = {
    initialState: void 0,
    context: void 0,
    countryCode: '',
    headers: void 0
}) {
    let { countryCode } = options;
    const { initialState, pageKey, headers } = options;
    if (!countryCode) {
        if (headers) {
            const { countryCode: _countryCode } = getG11nDataFromHeaders(headers);
            countryCode = _countryCode;
        } else if ("u" > typeof window) {
            const country = parseCookies(document.cookie).__creh_country_code;
            if (country && '*' !== country) countryCode = country.toLowerCase();
        }
    }
    const _apolloClient = apolloClient ?? createApolloClient(countryCode, pageKey);
    if (initialState) {
        const existingCache = _apolloClient.extract();
        _apolloClient.cache.restore({
            ...existingCache,
            ...initialState
        });
    }
    if ("u" < typeof window) return _apolloClient;
    if (!apolloClient) apolloClient = _apolloClient;
    return _apolloClient;
}
export { initializeApolloClient };
